"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSafari = void 0;
exports.isSafari = () => /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
//# sourceMappingURL=isSafari.js.map